import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "p-date" }
const _hoisted_2 = { class: "p-text" }
const _hoisted_3 = { class: "p-text" }
const _hoisted_4 = { class: "p-text" }


import moment from 'moment';

export default /*@__PURE__*/_defineComponent({
  __name: 'AppointmentItem',
  props: ['item'],
  setup(__props) {

const props = __props;
const appointmentTime = moment(props.item.time);

return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createBlock(_component_v_row, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_col, {
        class: "text-center",
        cols: "6"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: "2",
                class: "mr-0 pr-0"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_1, _toDisplayString(_unref(appointmentTime).date()), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "8",
                class: "mr-0 pr-0"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(appointmentTime).format('dddd')), 1),
                  _cache[0] || (_cache[0] = _createElementVNode("br", null, null, -1)),
                  _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(appointmentTime).format('MMM')) + " " + _toDisplayString(_unref(appointmentTime).format('YYYY')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "2",
                class: "mx-0 pl-0"
              }, {
                default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                  _createElementVNode("span", { class: "p-time" }, "10:00 10:30", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_col, {
        class: "text-center",
        cols: "4"
      }, {
        default: _withCtx(() => [
          _createElementVNode("span", _hoisted_4, _toDisplayString(props.item.name), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_v_col, {
        class: "text-center pr-5",
        cols: "2"
      }, {
        default: _withCtx(() => [
          (props.item.payment_status =='paid')
            ? (_openBlock(), _createBlock(_component_v_icon, {
                key: 0,
                icon: "fa-check-circle fa-2x pt-1",
                color: "green"
              }))
            : _createCommentVNode("", true),
          (props.item.payment_status =='unpaid')
            ? (_openBlock(), _createBlock(_component_v_icon, {
                key: 1,
                icon: "fa-question-circle fa-2x pt-1",
                color: "yellow"
              }))
            : _createCommentVNode("", true),
          (props.item.payment_status =='overdue')
            ? (_openBlock(), _createBlock(_component_v_icon, {
                key: 2,
                icon: "fa-warning fa-2x pt-1",
                color: "red"
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})